export const FIELDS = {
    bank_code : {
        title : "Bank Code",
        placeholder:"Bank Code"
    },
    bank_name : {
        title : "Bank Name",
        placeholder:"Bank Name"
    },
    account_code : {
        title : "Account Code",
        placeholder:"Account Code"
    },
    account_name : {
        title : "Account Holder Name",
        placeholder:"Account Holder Name"
    },
    account_no : {
        title : "Account Number",
        placeholder:"Account Number"
    },
    ifsc_code : {
        title : "IFSC Code",
        placeholder:"IFSC Code"
    },
    is_default : {
        title : "Is Default Bank"
    },
    created_by: "Created By",
    created_on: "Created On",
    updated_by: "Modified By",
    updated_on: "Modified On",
    edit: "Edit / Delete",
}

export const TITLES = {
    add : "Add Bank Details",
    edit : "Edit Bank Details"
}